module.exports = __webpack_public_path__ + "img/12.04eb7642.jpg";